import React from 'react';
import { Link } from 'react-router-dom';
import { Separator } from '../ui/separator';
import { MapPin, Phone, Mail } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="border-t" style={{ background: 'var(--brand-navy)', color: '#CBD5E1' }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg flex items-center justify-center text-white font-bold text-sm" style={{ background: 'var(--brand-teal)' }}>LC</div>
              <span className="font-semibold text-white" style={{ fontFamily: 'Space Grotesk' }}>Laminate Chillers</span>
            </div>
            <p className="text-sm text-slate-400 mb-4">Industrial water-cooled chiller solutions. Trusted by 500+ facilities. 35+ years of engineering knowledge.</p>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4" style={{ fontFamily: 'Space Grotesk' }}>Products</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/products/water-cooled-brine" className="hover:text-[var(--brand-teal-2)] transition-colors">Water Cooled Brine</Link></li>
              <li><Link to="/products/water-cooled-chilled-water" className="hover:text-[var(--brand-teal-2)] transition-colors">Water Cooled Chilled Water</Link></li>
              <li><Link to="/products/ammonia" className="hover:text-[var(--brand-teal-2)] transition-colors">Ammonia Chillers</Link></li>
              <li><Link to="/products/ultra-low-temp" className="hover:text-[var(--brand-teal-2)] transition-colors">Ultra Low Temperature</Link></li>
              <li><Link to="/products/custom" className="hover:text-[var(--brand-teal-2)] transition-colors">Custom Solutions</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4" style={{ fontFamily: 'Space Grotesk' }}>Company</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-[var(--brand-teal-2)] transition-colors">Why Choose Us</Link></li>
              <li><Link to="/news" className="hover:text-[var(--brand-teal-2)] transition-colors">News & Case Studies</Link></li>
              <li><Link to="/request-quote" className="hover:text-[var(--brand-teal-2)] transition-colors">Request a Quote</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4" style={{ fontFamily: 'Space Grotesk' }}>Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 shrink-0" /><span># 8 & 9/B, IDA Patancheru<br/>Behind Veljan Hydra, Sangareddy Dist.<br/>Hyderabad – 502319, Telangana, India</span></li>
              <li className="flex items-center gap-2"><Phone className="w-4 h-4 shrink-0" /><span>+91 90302 23423</span></li>
              <li className="flex items-center gap-2"><Mail className="w-4 h-4 shrink-0" /><span>laminatechillers@gmail.com</span></li>
            </ul>
          </div>
        </div>

        <Separator className="my-8 bg-slate-700" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <div>
            <p>&copy; {new Date().getFullYear()} Laminate Chillers Pvt. Ltd. All rights reserved.</p>
            <p className="mt-1 text-slate-400">Laminate Chillers – Leading Water Cooled Screw Chiller Manufacturer in Hyderabad, Telangana, India</p>
          </div>
          <div className="flex gap-4">
            <span>ISO 9001:2015 Certified</span>
            <span>CE Marked</span>
            <span>ASME U-Stamp</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
